export function transformJStoASRegExpMatchArray(sec, value) {
    var result = sec.createArray(value);
    result.axSetPublicProperty('index', value.index);
    result.axSetPublicProperty('input', value.input);
    return result;
}
